angular.module('bfControllers.subbyersRates', []).controller(
    'SubbuyersRatesController',
    ['$scope', '$rootScope', '$http', '$resource',
        function ($scope, $rootScope, $http, $resource) {
            this.ratesList = {};
            var self = this;

            /**
             * Get list of Subbuyer Rates
             * http://ec.term.biflorica:10000/api/Subbuyers/ratesList
             */
            this.getRates = function () {
                $rootScope.querySent = true;
                $resource(API_LINK + '/:action', {action: 'Subbuyers/ratesList'}, {get: {method: 'GET'}})
                    .get(function (result) {
                        self.ratesList = result.data.list;
                        $scope.rates = result.data.list;
                        $rootScope.querySent = false;
                    });
            };
            $rootScope.renewRates = this.getRates;

            $scope.fullListCheckerClick = function (selector) {
                let new_value = $(selector).prop('checked');
                $('INPUT[name="subbuyers[]"]').prop('checked', new_value);
            }

            /**
             * Действия, которые необходимо выполнить после восстановления соединения с сервером ноды
             */
            $rootScope.$on('afterReconnect', function (event, data) {
                $rootScope.renewRates();
            });

            // Действия после загрузки страницы
            this.getRates();
        }]);
